<template>
  <el-container class="root_container">
    <el-main class="bg-f5" style="padding:0px;">
      <div
        class="tt"
        v-if="$route.query.stype && data.image_url"
        style="width:100%;height:430px;overflow:hidden; text-align:center;"
      >
        <a :href="data.image_link"
          ><img :src="data.image_url" style="height:100%"
        /></a>
      </div>

      <div id="goodlist" class="fullWdth">
        <div style="width:100%;background:#fff;">
          <el-breadcrumb
            style="border-bottom: solid 1px #e6e6e6;height: 17px;font-size: 13px;font-family: MicrosoftYaHei;color: #272727;line-height: 17px; padding-top:20px;padding-bottom:20px;width:1190px;margin:0 auto;"
            separator-class="el-icon-arrow-right"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>

            <el-breadcrumb-item
              ><span style="color:#272727">{{
                type_name
              }}</span></el-breadcrumb-item
            >
          </el-breadcrumb>
          <div class="sortCont">
            <div
              class="fenlei"
              v-if="$route.query.stype != 1"
              style="padding-bottom:3px;"
            >
              <p>
                <span>商品分类:</span>
              </p>

              <ul style="height: auto" class="oh">
                <li style="">
                  <span
                    @click="catidclass()"
                    :class="
                      this.clas_id == '' || this.clas_id == undefined
                        ? 'theme-bg'
                        : ''
                    "
                    >全部</span
                  >
                </li>

                <li v-for="(items, index) in classesdatas" :key="items.id">
                  <span
                    :class="{ 'theme-col': items.id == clas_id }"
                    @click="catidPlay(items.id)"
                    class="text-cent"
                    >{{ items.name }}</span
                  >
                </li>
                <div class="clear"></div>
              </ul>
              <div class="clear"></div>
            </div>
            <div
              class="fenlei"
              style="padding-top: 13px;padding-bottom: 13px;line-height: 31px;"
            >
              <p>
                <span>价格筛选:</span>
              </p>

              <ul class="oh">
                <li>
                  <span
                    :class="{
                      'theme-bg': this.point_pre == '' && this.point_post == ''
                    }"
                    @click="catidporint()"
                    >不限</span
                  >
                </li>
                <li v-for="(items, index) in jfSectionDatas" :key="items.id">
                  <span
                    :class="{ 'theme-col': items.start === point_pre }"
                    @click="jfSectionPlay(items)"
                    >{{ items.start }}-{{ items.end }}</span
                  >
                </li>
                <li v-if="max_point != null">
                  <span
                    @click="jfSectionPlay(max_point)"
                    :class="{ 'theme-col': max_point == point_pre }"
                    >{{ max_point }}以上</span
                  >
                </li>
                <li class="enterPoint">
                  <input
                    v-model="point_pre"
                    type="text"
                    onkeyup="this.value=this.value.replace(/\D/g,'')"
                    onafterpaste="this.value=this.value.replace(/\D/g,'')"
                  />
                  <span style="color: #6A6A6A;">-</span>
                  <input
                    v-model="point_post"
                    type="text"
                    onkeyup="this.value=this.value.replace(/\D/g,'')"
                    onafterpaste="this.value=this.value.replace(/\D/g,'')"
                  />
                  <button class="qued" @click="getData()">确定</button>
                </li>
                <div class="clear"></div>
              </ul>
              <div class="clear"></div>
            </div>
            <div class="fenlei">
              <p>
                <span>商品排序:</span>
              </p>

              <ul style="height: auto" class="oh">
                <li>
                  <span
                    :class="{
                      'theme-bg': this.add_time != true && this.type != 2
                    }"
                    @click="catid()"
                    >默认</span
                  >
                </li>
                <li
                  @click="shopsortPlay(1)"
                  :class="add_time == true ? 'theme-col' : ''"
                >
                  时间
                </li>
                <!-- <li @click="shopsortPlay(3)" :class="sale===0||sale==1?'theme-col':''">兑换量</li> -->
                <li
                  @click="shopsortPlay(2)"
                  :class="type == 2 ? 'theme-col' : ''"
                >
                  {{ $store.state.name }}
                  <span>
                    <i
                      :class="
                        this.type == 2 && this.price == 0 ? 'theme-col' : 'FFF'
                      "
                      class="el-icon-caret-top"
                    ></i>
                    <i
                      :class="
                        this.type == 2 && this.price == 1 ? 'theme-col' : 'FFF'
                      "
                      class="el-icon-caret-bottom"
                    ></i>
                  </span>
                </li>
                <div class="clear"></div>
              </ul>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div class="controlWdth">
          <div
            class="listCont"
            :style="allPage >= 1 ? '' : 'margin-bottom:25px'"
          >
            <el-row v-if="datalist != ''" class="oh ">
              <el-col
                v-for="(items, index) in datalist"
                :key="items.id"
                class="goodsitem marginL10"
                :style="
                  $store.state.webInfo.market_status == 1
                    ? 'height:350px'
                    : 'height:350px'
                "
              >
                <div class="grid-content bg-purple-light">
                  <router-link
                    tag="a"
                    target="_blank"
                    :to="{ name: 'Detail', params: { id: items.id } }"
                    style="padding-bottom: 5px;position: relative;"
                  >
                    <img
                      v-lazy="items.image"
                      onerror="src='/static/imgout2.png'"
                      alt
                      style="margin: 0px 0px 5px 0px;width: 210px;height:210px;"
                      lazy
                    />
                    <div
                      class="nostock"
                      v-if="pagesocket[items.id_spro] == '无货'"
                    >
                      暂无库存
                    </div>
                    <p
                      class="goodsName ellipseal"
                      style="text-align: left;height: 48px;font-size: 14px;font-family: MicrosoftYaHei;color: #272727;line-height: 24px;"
                      :title="items.name"
                    >
                      <span class="jd" v-show="items.source == 1">优选</span>
                      <span class="yx" v-show="items.source == 6">严选</span>
                      <span class="new" v-show="items.source == 2">直充</span>
                      <span class="rob" v-show="items.source == 3">卡券</span>
                      {{ items.name }}
                    </p>
                  </router-link>
                  <div
                    class=""
                    style="display: flex;margin-top:7px;
    justify-content: space-between;    align-items: center;"
                  >
                    <div>
                      <p class="paddingL20 price text-left">
                        <span style="color:#bebebe;font-size:12px;">
                          <span
                            class="theme-col"
                            style="height: 21px;font-size: 16px;font-family: MicrosoftYaHei;color: #E53940;line-height: 21px;"
                            v-if="items.price_points"
                          >
                            {{ items.price_points }}{{ $store.state.name }}
                          </span>
                          <span
                            class="theme-col"
                            style="height: 21px;font-size: 16px;font-family: MicrosoftYaHei;color: #E53940;line-height: 21px;"
                            v-if="items.price_cash"
                          >
                            <span v-if="items.price_points">+</span>{{ items.price_cash }}元
                          </span>
                        </span>
                      </p>
                      <!--  v-if="$store.state.webInfo.market_status==1" -->
                      <p class="price text-left" style="margin-top: 0px;">
                        <span
                          v-if="items.stock_status === 1 && $store.state.mallStockShow"
                          style="font-size: 12px;font-family: MicrosoftYaHei;color: #989898;line-height: 16px; margin-top:4px;"
                        >
                          <span>库存：{{ items.stock_number }}</span>
                        </span>
                        <span
                          v-else
                          style="font-size: 12px;font-family: MicrosoftYaHei;color: #989898;line-height: 16px; margin-top:4px;"
                        >
                          <span>&nbsp;</span>
                        </span>
                      </p>
                      <p class="price text-left" style="margin-top: 0px;">
                        <span
                          v-if="$store.state.webInfo.market_status == 1"
                          style="text-decoration:line-through;font-size: 12px;font-family: MicrosoftYaHei;color: #989898;line-height: 16px; margin-top:4px;"
                        >
                          <span>市场价:{{ items.market_price }}</span>
                          元
                        </span>
                      </p>
                    </div>
                    <div v-if="items.source == 3 || items.source == 2">
                      <el-button
                        @click="addTs()"
                        icon="cart"
                        style="width: 40px;height: 40px;background: #BEBEBE; border-radius: 50%; border:none;   align-items: center;
    display: flex;
    justify-content: center;margin-right:5px;"
                      ></el-button>
                    </div>
                    <div v-else>
                      <el-button
                        icon="cart"
                        @click="addcart(items.id)"
                        style="width: 40px;height: 40px;background: #E23130; border-radius: 50%; border:none;   align-items: center;
    display: flex;
    justify-content: center;margin-right:5px;"
                      ></el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="searchgoods" v-if="datalist == '' && name != ''">
              <img src="/static/img/search.png" alt />
              <div>
                <p>抱歉，没有搜索到与“{{ this.name }}”相关的任何结果</p>
                你可以换个关键词再试
              </div>
            </div>
            <div
              class="searchgoods"
              v-if="datalist == '' && name == '' && loading == false"
            >
              <img src="/static/img/nodata.png" alt />
              <p>暂无数据</p>
            </div>
          </div>
          <div
            style="margin: 5px 0px 40px 0px;text-align: center"
            class="block"
            v-if="allpage > 1"
          >
            <el-pagination
              layout="prev,pager, next"
              :total="allpage * count"
              :page-size="count"
              :current-page.sync="page"
            ></el-pagination>
          </div>
          <div v-if="loading && datalist == ''" class="loading">
            <span>加载中……</span>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import Mixins from "../../../static/js/mixins";
export default {
  data() {
    return {
      data: {},
      type_name: "",
      loading: true,
      allpage: 0, //全部页数
      datalist: [], //商品列表
      count: 20, //显示数量
      page: 1, //页码
      clas_id: this.$route.query.classid, //分类ID
      stype: this.$route.query.stype,
      sale: "", //销量
      price: "", //价格
      add_time: "", //时间
      point_pre: "", //区间前置
      point_post: "", //区间后置
      name:
        this.$route.query.keyword == undefined ? "" : this.$route.query.keyword, //产品名称
      total: "",
      classesdatas: this.$route.query.classesdatas, //商品分类
      numId: "", //选中的分类ID
      type: 0,
      jfSectionDatas: [
        { start: 0, end: 500 },
        { start: 500, end: 1000 },
        { start: 1000, end: 2000 }
      ], //积分区间数据
      max_point: 2000,
      popAddress: this.$store.state.address,
      pagesocket: {}
    };
  },
  mixins: [Mixins],
  watch: {
    $route(to, form) {
      if (to.name == "Goodslist") {
        this.$route.query.mypoint == 1
          ? (this.point_post = this.$store.state.userinfo.point)
          : (this.point_post = "");
        this.name = this.$route.query.keyword;
        this.clas_id = this.$route.query.classid;
        this.page = 1;
        this.getData();
      }
    },
    page(oldV, newV) {
      this.getData();
    },
    "$store.state.address.ti": function() {
      (this.popAddress = this.$store.state.address),
        localStorage.setItem(
          "messageStore1",
          JSON.stringify(this.$store.state)
        );
      this.getData();
    }
  },
  methods: {
    addTs() {
      this.$message({
        message: "该商品不能加人购物车,请点击进入商品详情直接兑换"
      });
    },
    getData() {
      this.loading = true;
      console.log(this.$route.query.stype);
      if (this.clas_id == undefined) {
        this.clas_id = "";
      }
      this.$api.get(
        "product/goodslist",
        {
          id_example: this.$store.state.id_example,
          clas_id: this.clas_id, //分类ID
          stype: this.$route.query.stype, //分类ID
          sale: this.sale, //销量
          price: this.price, //价格
          add_time: this.add_time, //时间
          point_pre: this.point_pre, //区间前置
          point_post: this.point_post, //区间后置
          name: this.name, //产品名称
          page: this.page, //页码
          count: this.count //每页默认显示数量
        },
        res => {
          if (res.data.code == 100) {
            this.type_name = res.data.data.type_name;
            this.data = res.data.data;
            this.datalist = res.data.data.list;
            this.allpage = res.data.data.total_page;
            this.loading = false;
            var arr = "";
            for (let i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].source == 1) {
                arr += res.data.data.list[i].id_spro + ",";
              }
            }
            this.checksocket(arr);
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    checksocket: function(id) {
      //查询京东库存
      id = id.substr(0, id.length - 1); //地址
      this.$api.get(
        "/product/jd/stock",
        {
          id_example: this.$store.state.id_example,
          id_product: id,
          id_province: this.popAddress.id[0],
          id_city: this.popAddress.id[1],
          id_county: this.popAddress.id[2]
        },
        res => {
          if (res.data.code == "100") {
            res.data.data.forEach(item => {
              this.$set(this.pagesocket, item.code, item.desc);
            });
          }
        }
      );
    },
    getscreen() {
      //积分筛选列表
      var _this = this;
      this.$api.get(
        "product/filterMenu",
        {
          id_example: this.$store.state.id_example
        },
        res => {
          if (res.data.code == 100) {
            if (res.data.data.list.length != 0) {
              this.jfSectionDatas = [];
              $.each(res.data.data.list, function(index, items) {
                _this.jfSectionDatas.push(items);
              });
              this.max_point = res.data.data.max_point;
            }
          }
        }
      );
    },
    getClass() {
      //商品分类
      this.$api.get(
        "sys/typelist",
        {
          id_example: this.$store.state.id_example,
          name: "",
          terminal: "pc"
        },
        res => {
          this.classesdatas = res.data.data;
        }
      );
    },
    //分类筛选
    catidPlay(id) {
      this.page = 1;
      this.name = "";
      this.clas_id = id;
      this.getData();
    },
    //默认
    catid() {
      this.add_time = "";
      this.sale = "";
      this.type = "";
      this.price = "";
      this.getData();
    },
    //积分筛选
    jfSectionPlay(porint) {
      //如果选中最大值
      if (typeof porint == "number") {
        this.point_pre = porint;
        this.point_post = "";
      } else {
        this.point_pre = porint.start; //区间前置
        this.point_post = porint.end; //区间后置
      }
      this.name = "";
      this.page = 1;
      this.getData();
    },
    catidclass() {
      this.page = 1;
      this.name = "";
      this.clas_id = "";
      this.getData();
    },
    catidporint() {
      this.page = 1;
      this.point_pre = ""; //区间前置
      this.point_post = ""; //区间后置
      this.getData();
    },
    shopsortPlay(type) {
      if (type == 1) {
        this.type = 1;
        this.sale = "";
        this.price = "";
        this.add_time = 1; //时间
        this.page = 1;
      } else if (type == 2) {
        this.sale = "";
        this.add_time = "";
        this.type = 2;
        this.price === 0 ? (this.price = 1) : (this.price = 0); //价格
        this.page = 1;
      } else if (type == 3) {
        this.type = 3;
        this.add_time = "";
        this.price = "";
        this.sale == 0 ? (this.sale = 1) : (this.sale = 0); //销量
        this.page = 1;
      }
      this.getData();
    }
  },
  mounted() {
    this.$route.query.mypoint == 1
      ? (this.point_post = this.$store.state.userinfo.point)
      : "";
    // this.getClass();
    this.classesdatas = this.$store.state.classesdatas;
    this.getData();
    this.getscreen();
  }
};
</script>
<style lang="less" scoped>
.oh {
  overflow: initial;
}
.qued:hover {
  background: #fff !important;
}
/deep/ .cart {
  background: url(/static/img/cart-icong.svg) no-repeat center center;
  background-size: 80%;
  width: 22px;
  height: 22px;
  padding: 5px 15px;
  display: inline-block;
}

.theme-bg {
  color: #e53940 !important;
  background-color: #fff !important;
}
.el-breadcrumb__separator {
  color: #b1b1b1;
}
.el-breadcrumb__inner {
  color: #7a7a7a;
}
.goodsitem {
  width: 230px;
  height: 327px;
  padding: 10px 10px;
  background: white;
  margin: 0px 5px 15px 5px;
  position: relative;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.2s linear;
  a img {
    transition: all 0.25s ease;
  }
}
.goodsitem:hover {
  transform: translate3d(0, -2px, 0);

  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
  a img {
    opacity: 0.9;
  }
}
.nostock {
  position: absolute;
  width: 90px;
  height: 90px;
  text-align: center;
  line-height: 90px;
  color: white;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  margin-top: -45px;
  margin-left: -45px;
  background-color: rgba(38, 38, 38, 0.9);
}
#goodlist .fenlei {
  height: auto;
  padding: 11px 0;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  position: relative;
  padding-left: 86px;
  // min-height: 20px;
  padding-top: 18px;
  padding-bottom: 16px;
}
#goodlist .fenlei:last-child {
  border-bottom: none;
}
// #goodlist .fenlei i {
//   position: relative;
//   top: -1px;
//   font-size: 18px;
// }
#goodlist .fenlei li {
  float: left;
  /*width: 85px;*/
  margin-right: 30px;
  /*font-size: 15px;*/
  color: #272727;
  text-align: left;
  margin-bottom: 10px;
  // height: 30px;
  // line-height: 30px;
}
.allfeilei {
  float: left;
  // margin-top: 5px;
  margin-right: 32px;
  font-size: 14px;
  text-align: center;
  display: inline-block;
  margin-left: 16px;
  // height: 20px;
  // width: 38px;
}
#goodlist .fenlei p {
  // width: 100px;

  // margin-top: -17px;
  // border-right: 1px solid #ddd;
  float: left;
  font-size: 14px;
  color: #535353;
  position: absolute;
  left: 0;
  // top: 50%;
}

/*商品样式结束*/
.sortCont {
  font-size: 16px;
  width: 1190px;
  margin: auto;
  margin-bottom: 40px;
}

.classify,
.brandprice,
.filter {
  height: 50px;
  line-height: 50px;
  background: #fff;
  border-bottom: 1px dashed #ddd;
}
.filter {
  border-bottom: none;
}
.brandprice p,
.filter p {
  width: 100px;
  height: 34px;
  line-height: 30px;
  margin-top: 8px;
  // border-right: 1px solid #ddd;
  float: left;
  font-size: 14px;
  color: #565656;
}

.classify p i,
.brandprice p i,
.fenlei i {
  position: relative;
  top: -1px;
  font-size: 18px;
}
.classify li {
  float: left;
  /*width: 85px;*/
  margin-right: 15px;
  font-size: 15px;
  text-align: left;
}
.filter li {
  float: left;
  width: 65px;
  margin-right: 15px;
  font-size: 15px;
  text-align: center;
}
.fenlei li i {
  margin: 0 0 0 0px;
  position: relative;
  top: -4px;
  font-size: 10px;
}
.fenlei li span {
  position: relative;
}
.fenlei li .el-icon-caret-bottom {
  position: absolute;
  top: 8px;
  left: 0;
}

.brandprice li {
  float: left;
  margin-right: 15px;
  font-size: 15px;
}
.brandprice ul {
  width: 680px;
  float: left;
}
.brandprice li:nth-child(1),
.classify li:nth-child(1),
.filter li:nth-child(1) {
  width: 65px;
  text-align: center;
}

.enterPoint {
  float: right !important;
  // width: 252px;
  text-align: left;
  margin-right: 0px !important;
}
.enterPoint input {
  width: 89px;
  height: 31px;
  border: none;
  background: #f3f3f3;
  padding: 0 5px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #dadada;
  transition: all 0.25s;
}
.enterPoint input:hover,
.enterPoint input:focus {
  background: #fff;
}
.enterPoint button {
  transition: all 0.25s;
  margin-left: 10px;
  width: 68px;
  height: 31px;
  background: #f5f5f5;
  border-radius: 4px;
  color: #272727;
  border: 1px solid #dadada;
  /*box-sizing:border-box;*/
}
.number {
  background: none;
  width: 35px !important;
  height: 35px !important;
  background: #ffffff !important;
  border-radius: 3px !important;
  border: 1px solid #e7e7e7 !important;
}
/deep/ .el-pager li {
  width: 35px !important;
  height: 35px !important;
  background: #ffffff !important;
  border-radius: 3px !important;
  border: 1px solid #e7e7e7 !important;
  margin: 0px 2.5px !important;
}
/deep/ .el-pagination .btn-next,
/deep/.el-pagination .btn-prev {
  width: 35px !important;
  height: 35px !important;
  background: #ffffff !important;
  border-radius: 3px !important;
  border: 1px solid #e7e7e7 !important;
  margin: 0px 2.5px !important;
}
/deep/ .el-pager li.active {
  color: #e53940 !important;
  background: rgba(229, 57, 64, 0.1) !important;
  border: 1px solid #e53940 !important;
}
.searchgoods {
  margin: 185px 0 200px;
  color: #7a7a7a;
  img {
    margin-bottom: 15px;
    width: 252px;
  }
  div {
    color: #7a7a7a;
  }
  p {
    font-size: 13px;
    font-family: MicrosoftYaHei;
    color: #7a7a7a;
    line-height: 24px;
  }
}
.FFF {
  color: #565656;
}
.loading {
  height: 400px;
  line-height: 400px;
  font-size: 30px;
  background: white;
  margin-bottom: 50px;
  text-align: center;
  span {
    width: 200px;
    font-family: "宋体";
    font-weight: 600;
    display: inline-block;
    font-style: italic;
    background-image: -webkit-linear-gradient(
      left,
      #f3f3f3,
      #cccccc 25%,
      #f3f3f3 50%,
      #cccccc 75%,
      #f3f3f3
    );
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-background-size: 200% 100%;
    -webkit-animation: masked-animation 4s infinite linear;
  }
}
@-webkit-keyframes masked-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -100% 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/goodslist.vue